<div class="d-flex flex-column justify-content-start align-items-stretch h-100 w-100 my-3">

    <div *ngIf="schedules">

        <div *ngFor="let schedule of schedules" class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">

            <div class="bg-accent-lighter-color w-100 mb-1 p-2">
                <span class="fs-6 fw-bolder">{{schedule.description}}</span>
            </div>

            <app-class-selector
                class="w-100 mb-1"
                [showClear]="true"
                [classes]="getClassesFromSchedule(schedule)"
                [(selected)]="getSelectedOption(schedule).class"
                (selectedChange)="onSelectedClassChange(schedule)">
            </app-class-selector>

            <div *ngIf="getSelectedOption(schedule).class?.extraServices.length > 0" class="w-100">

                <div class="bg-primary-light-color w-100 p-2">

                    <div class="d-flex flex-column justify-content-center align-items-start w-100">

                        <div class="w-100 mb-1 p-2">
                            <span class="fs-6 fw-bold">{{labels.extraServicesSelectorLabel}}</span>
                        </div>

                        <div *ngFor="let extra of getSelectedOption(schedule).class.extraServices">

                            <div class="d-flex flex-row justify-content-center align-items-start w-100 ps-2">

                                <p-checkbox
                                    class="me-2"
                                    [inputId]="extra.extraServiceId.toString()"
                                    [binary]="true"
                                    (onChange)="onExtraCheckboxChange($event, schedule, extra)">
                                </p-checkbox>

                                <label [for]="extra.extraServiceId.toString()">
                                    {{ extra.displayName }} (+{{ extra.price }}€)
                                </label>

                            </div>

                        </div>

                    </div>


                </div>

            </div>

        </div>

        <div *ngIf="showDuplicatedAlertMessage" class="alert alert-danger" role="alert">
            <span class="fs-6">{{labels.duplicatedAlertMessage}}</span>
        </div>
         <div *ngIf="showClassFullAlertMessage" class="alert alert-danger" role="alert">
            <span class="fs-6">{{classFullAlertMessage}}</span>
        </div>

    </div>

</div>
